import React, { Fragment, useState } from 'react'
import propTypes from 'prop-types'

import LateralPanel from '../../common/lateralPanel/LateralPanel'
import { panelLateralServicesStyles } from '../../../resources/styles/PanelLateralServicesStyles'
import { DialogView } from '../../common/Dialog'
import AlertComponent from '../../common/AlertComponent'

/** Material UI import section */
import { Fab, Typography, TextField, Button, CircularProgress } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Clear'
import SaveIcon from '@material-ui/icons/Save'

import iconFailureDoor from '../../../resources/images/failureWarranty/door.svg'
import { Skeleton } from '@material-ui/lab'

/**
 * Lateral panel to capture PO # once and apply it to every line item of the open folio.
 * Requires explicit overwrite confirmation before applying, since the operation overwrites existing values.
 * Reference is intentionally not offered here — it can only be edited per line item.
 */
const PanelBulkPoReference = (props) => {
	const classes = panelLateralServicesStyles()
	const [poNumber, setPoNumber] = useState('')
	const [confirmOpen, setConfirmOpen] = useState(false)

	const canBeApplied = () => !poNumber

	const onRequestApply = () => setConfirmOpen(true)
	const onCancelConfirm = () => setConfirmOpen(false)
	const onConfirmApply = () => {
		setConfirmOpen(false)
		props.onApply(poNumber)
	}

	return (
		<Fragment>
			<LateralPanel open={props.open} onClose={props.onClose}>
				<form>
					<PanelHeader
						onClose={props.onClose}
						isSaving={props.isSaving || canBeApplied()}
						title='BULK PO #'
						onSave={onRequestApply}
					/>
					<div className={classes.panelContent}>
						{props.isSaving ? (
							<SavingSkeleton />
						) : (
							<Fragment>
								<br />
								<TextField
									fullWidth
									name='PoNumber'
									variant='outlined'
									margin='dense'
									label='PO #'
									value={poNumber}
									onChange={(event) => setPoNumber(event.target.value)}
								/>
							</Fragment>
						)}
					</div>
				</form>
			</LateralPanel>
			<DialogView
				open={confirmOpen}
				onClose={props.isSaving ? undefined : onCancelConfirm}
				isSaving={props.isSaving}
				maxWidth='xs'
				header={<strong>Confirm operation</strong>}
				actions={
					<Button
						onClick={onConfirmApply}
						color='primary'
						variant='contained'
						disabled={props.isSaving}
						startIcon={props.isSaving ? <CircularProgress size={16} color='inherit' /> : null}
					>
						{props.isSaving ? 'Applying…' : 'Apply to all'}
					</Button>
				}
			>
				<AlertComponent
					severityType='warning'
					title='Warning'
					message='This will overwrite the PO # on every line item of this folio, including any value already captured. This action cannot be undone.'
				/>
			</DialogView>
		</Fragment>
	)
}

PanelBulkPoReference.propTypes = {
	open: propTypes.bool.isRequired,
	onClose: propTypes.func.isRequired,
	onApply: propTypes.func.isRequired,
	isSaving: propTypes.bool
}
PanelBulkPoReference.defaultProps = {
	open: false,
	isSaving: false
}
export default PanelBulkPoReference

/**
 * Panel header
 * @param {*} props
 */
const PanelHeader = (props) => {
	const { title, onClose, isSaving, onSave } = props
	const classes = panelLateralServicesStyles()

	return (
		<div className={classes.panelHeader}>
			<div className={classes.containerHeader}>
				<div className={classes.containerIcon}>
					<Fab size='medium' className={classes.faultWarrantyIconSelected} disabled={true}>
						<img src={iconFailureDoor} alt='warranty-icon' className={classes.faultWarrantyIcon} />
					</Fab>
				</div>
				<div className={classes.containerText}>
					<Typography gutterBottom variant='subtitle1' className={classes.title}>
						{title}
					</Typography>
				</div>
			</div>
			<div className={classes.grow} />
			<Fab className={classes.buttonSaved} disabled={isSaving} onClick={onSave}>
				<SaveIcon />
			</Fab>
			<Fab className={classes.buttonClose} onClick={onClose}>
				<DeleteIcon />
			</Fab>
		</div>
	)
}

const SavingSkeleton = () => {
	return (
		<Fragment>
			<Skeleton animation='wave' height={60} />
			<Skeleton animation='wave' height={60} />
		</Fragment>
	)
}
